import React from 'react';

export const Dialog = ({ open, onOpenChange, children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true">
      <button
        type="button"
        className="ui-modal-backdrop"
        onClick={() => onOpenChange?.(false)}
        aria-label="Close"
      />
      {children}
    </div>
  );
};

export const DialogContent = ({ children, className = '' }) => (
  <div className={`ui-modal-panel max-w-2xl p-6 ${className}`}>
    {children}
  </div>
);

export const DialogHeader = ({ children }) => (
  <div className="mb-4">
    {children}
  </div>
);

export const DialogTitle = ({ children }) => (
  <h2 className="text-xl font-bold">{children}</h2>
);

export const DialogTrigger = ({ children }) => children;

export const DialogFooter = ({ children }) => (
  <div className="flex justify-end gap-2 pt-4">
    {children}
  </div>
);
